<div class="page">
    <div class="page-content">
        <div class="container text-center">
            <div class="display-1 text-muted mb-5"><i class="si si-exclamation"></i> 404</div>
            <h2 class="mb-3">Stranica koju tražite nije pronađena</h2>
            <h4 class="text-muted fw-normal mb-7">Ukoliko ste uneli URL direktno, molimo Vas proverite da li ste ga uneli tačno.</h4>
            <button class="btn btn-primary" (click)="goBack()">
                <i class="fe fe-arrow-left me-2"></i>Nazad na početnu
            </button>
        </div>
    </div>
</div>